import { setBanner } from 'actions/banner';
import { ContainerSP } from 'pages/home/banner';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-scroll';
import { Link } from 'react-router-dom';
import API from 'repository';

const LipidBond: React.FC<{
    setDataBanner: Function;
    dataBanner: any;
}> = ({ setDataBanner, dataBanner }) => {
    const fetchBanner = async () => {
        try {
            const response = await API.getBanner();
            if (response) {
                setDataBanner(response);
            }
        } catch (er) {
            console.log(er);
        }
    };

    useEffect(() => {
        if (dataBanner?.length === 0) {
            fetchBanner();
        }
    }, []);

    const ImageAndDescription = ({ img, des }: { img: string; des: any }) => {
        return (
            <div className="sm:px-4 px-0 flex-col flex items-center justify-center">
                <img src={img} alt="img" className="w-full" />
                <p className="sm:w-[465px] w-full text-center sm:text-[15px] text-[14px] sm:pt-6 pt-2 text-[#20489B]">
                    {des}
                </p>
            </div>
        );
    };

    return (
        <div className="home">
            <div className="px-1 home__slide md:px-0">
                <ContainerSP />
            </div>
            <div className="layout lg:px-0 px-2">
                <p className="text-[20px] text-center max-md:text-base sm:py-5 py-0 font-bold uppercase text-[#20489B]">
                    MOYO ứng dụng công nghệ Lipid Bond - Bước tiến mới phục hồi
                    & giảm rụng tóc
                </p>
                <p className="text-[#20489B] pb-3">
                    MOYO vinh dự góp mặt trong Hội thảo khoa học do Bệnh viện Da
                    liễu TP.HCM phối hợp cùng Laborie Derma tổ chức – một dấu
                    mốc quan trọng trong hành trình chăm sóc và phục hồi tóc tại
                    Việt Nam với công nghệ Lipid Bond.
                </p>

                <ImageAndDescription
                    des="MOYO tham dự Hội thảo khoa học tại Bệnh viện Da liễu TP.HCM. 
(Ảnh: Laborie Derma)"
                    img="/LABORIE-DERMA-1143.png"
                />
                <div className="mt-8">
                    <ImageAndDescription
                        des="Công nghệ Phân tử nhỏ Lipid Bond được công nhận và ứng dụng tại Bệnh viện Da Liễu TP.HCM (Ảnh: Laborie Derma)"
                        img="/LABORIE-DERMA-1014.png"
                    />
                </div>
                <div className="mt-8">
                    <ImageAndDescription
                        des="Đại diện Bệnh viện Da Liễu TP.HCM chia sẻ về Công nghệ Lipid Bond trong trị liệu da đầu. (Ảnh: Laborie Derma)"
                        img="/LABORIE-DERMA-1133.png"
                    />
                </div>
                <div className="mt-8">
                    <ImageAndDescription
                        des="Các chuyên gia đầu ngành Bệnh viện Da Liễu TP.HCM tham gia trao đổi về giải pháp điều trị rụng tóc. (Ảnh: Laborie Derma)"
                        img="/LABORIE-DERMA-1012.png"
                    />
                </div>
                <div className="text-[20px] my-7 max-md:text-base font-bold uppercase pl-2 text-[#20489B] relative border-l-[6px] border-[#EF4E24]">
                    Công nghệ Lipid Bond – Giải pháp đột phá cho tóc hư tổn
                </div>

                <div className="flex flex-col text-[#20489B] ">
                    <span>
                        Công nghệ Lipid Bond sử dụng các phân tử nhỏ có khả năng
                        thẩm thấu sâu vào lõi tóc, giúp:
                    </span>

                    <span>
                        - Hàn gắn các liên kết protein bị đứt gãy do hóa chất &
                        tác động nhiệt.
                    </span>
                    <span>
                        - Tái tạo lớp lipid tự nhiên, giúp tóc bóng mượt & dẻo
                        dai hơn.
                    </span>
                    <span>
                        - Củng cố nang tóc, giảm tình trạng gãy rụng & kích
                        thích tóc phát triển khỏe mạnh.
                    </span>
                </div>
                <div className="py-7">
                    <ImageAndDescription
                        des="Cơ chế bọc lipid dưỡng chất quanh chân tóc giúp giảm đứt gãy, rụng & kích mọc tóc. (Ảnh: Laborie Derma)"
                        img="/images-1.png"
                    />
                </div>
                <div className="hidden sm:flex">
                    <ImageAndDescription
                        des="Hình ảnh khách hàng trước và sau khi sử dụng dịch vụ phục hồi ứng dụng Công nghệ Lipid Bond tại MOYO. (Ảnh: MOYO)"
                        img="/image-2.png"
                    />
                </div>
                <div className="sm:hidden flex">
                    <ImageAndDescription
                        des="Hình ảnh khách hàng trước và sau khi sử dụng dịch vụ phục hồi ứng dụng Công nghệ Lipid Bond tại MOYO. (Ảnh: MOYO)"
                        img="/image-2.1.png"
                    />
                </div>
                <div className="text-[20px] my-7 max-md:text-base font-bold uppercase pl-2 text-[#20489B] relative border-l-[6px] border-[#EF4E24]">
                    MOYO – Ứng dụng toàn diện CÔNG NGHỆ LIPID BOND vào các dịch
                    vụ
                </div>
                <p className="text-[#20489B] ">
                    MOYO sử dụng trọn bộ sản phẩm LABORIE Derma và Công nghệ
                    Lipid Bond trong các line dịch vụ, đặc biệt nổi bật với 2
                    liệu trình{' '}
                    <span className="font-bold">
                        Phục Hồi Nang Tóc 7in1 Premium Lipid Bond & Phục Hồi Trẻ
                        Hoá 10in1 Toàn Diện
                    </span>{' '}
                    – lựa chọn yêu thích của khách hàng nhờ hiệu quả rõ rệt ngay
                    từ lần đầu trải nghiệm.
                </p>
                <ImageAndDescription
                    des={
                        <p className="text-[#20489B] ">
                            <span className="font-bold">
                                Phục Hồi Nang Tóc 7in1 Premium Lipid Bond
                            </span>{' '}
                            kết hợp Công nghệ phục hồi Lipid Bond và Nanotech
                            cho tóc mềm óng, giảm gãy rụng.
                        </p>
                    }
                    img="/image-3.png"
                />
                <ImageAndDescription
                    des={
                        <p className="text-[#20489B] ">
                            <span className="font-bold">
                                Phục Hồi Trẻ Hoá 10in1 Toàn Diện
                            </span>{' '}
                            sử dụng toàn bộ Liệu trình Phục hồi toàn diện Lipid
                            Bond từ Laborie Derma.
                        </p>
                    }
                    img="/IMG_6479.png"
                />
                <ImageAndDescription
                    des={
                        <p className="text-[#20489B] ">
                            <span className="font-bold">
                                Full Liệu Trình Phục hồi Toàn diện Laborie Derma
                            </span>{' '}
                            phục hồi tổn thương do hóa chất, nhiệt, môi trường
                            chỉ trong vài phút.
                        </p>
                    }
                    img="/banner-laborie-07.png"
                />
                <div className="flex items-center justify-center py-5">
                    <Link
                        className="transition-all border bg-[#EF4E24] text-white font-bold text-base rounded-[10px] px-5 py-2 lg:py-3 hover:bg-[#022770] hover:text-[#fff] min-w-[250px] text-center"
                        // to="/"
                        to={`/booking?salonId=0&phone=0&step=0`}
                    >
                        ĐẶT LỊCH NGAY
                    </Link>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        trackingData: state.trackingData,
        userPhone: state.user.phoneNumber,
        dataBanner: state.dataBanner,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setDataBanner: (value: any) => dispatch(setBanner(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LipidBond);
